import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { TCategory } from '@/types/category';

dayjs.extend(utc);
export const displayName = 'Polako Hedonist';

export const externalLinks = {
    telegram: 'https://t.me/polakohedonist',
    instagram: 'https://www.instagram.com/polakohedonist/',
    instagram_rs: 'https://www.instagram.com/polakohedonist.rs/',
    partnership: 'https://t.me/polakohedonistadmin',
    donation: 'https://destream.net/live/PolakoHedonist/donate',
    email: 'support@polakohedonist.rs',
    instagram_base: 'https://www.instagram.com/',
    telegram_base: 'https://t.me/',
    alta_pay: 'https://altapay.rs/',
    mc_check: 'https://www.mastercard.com/rs/consumer/credit-cards.html',
    viber_download: 'https://www.viber.com/en/download/',
    visa_secure: 'https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html',
    adminPanel: process.env.NEXT_SERVER_ADMIN_PANEL_URL || '',
    clientRoot: process.env.NEXT_SERVER_CLIENT_ROOT_URL || '',
    clientRS: process.env.NEXT_SERVER_CLIENT_RS_URL || '',
    clientDeprecated: process.env.NEXT_SERVER_CLIENT_DEPRECATED_URL || '',
};

/** The property values will be "undefined" on the client-side */
export const assetsServer = {
    buildId: process.env.NEXT_SERVER_BUILD_ID || '',
    logoPrimarySmall: process.env.NEXT_SERVER_LOGO_PRIMARY_SMALL_URL || '',
    introBackground: process.env.NEXT_SERVER_INTRO_BG_URL || '',
    opengraphImage: process.env.NEXT_SERVER_OG_IMAGE_URL || '',
};

export const assetsShared = {
    logoPrimary: process.env.NEXT_PUBLIC_LOGO_PRIMARY_URL || '',
    defaultCoverImage: process.env.NEXT_PUBLIC_DEFAULT_COVER_IMAGE_URL || '',
};

export const storageEdgeUrl = process.env.NEXT_PUBLIC_STORAGE_EDGE_URL || '';

export const screenBreakpoints = {
    xs: 414,
    sm: 512,
    md: 650,
    lg: 768,
    xl: 1024,
    xxl: 1280,
};

export const regexPaterns = {
    phone: /^\+\d+$/,
    telegram: /https:\/\/t\.me\//,
    instagram: /https:\/\/www\.instagram\.com\//,
    email: /^[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,}$/,
    gmaps: /^https?:\/\/(maps\.app\.goo\.gl\/[\dA-Za-z]+|www\.google\.com\/maps\/place\/[\w+\-]+)/,
    sanitizeText: /[^A-Za-zĆćČčĐđŠšŽžА-я]/g,
    sanitizeEmail: /[^\w+.@ĆćČčĐđŠšŽžА-я\-]/g,
    sanitizeSocialLink: /[^\s\w%&./:=?@-]/g,
    sanitizePhone: /^\+\d+$/,
    sanitizeTextAndNumbers: /[^\d\s,A-Za-zĆćČčĐđŠšŽžА-я\-]/g,
};

export const apiBaseUrl = process.env.NEXT_PUBLIC_BACKEND_URL || '';
export const apiPaymentsUrl = process.env.NEXT_PUBLIC_PAYMENT_SERVICE_URL || '';
export const apiMetabase = process.env.NEXT_PUBLIC_METABASE_SERVICE_URL || '';
export const recaptchaSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

export const amplitudeApiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || '';

export const storageKeys = {
    eventCardExpanded: 'eventCard_expanded',
    eventCardNavigationId: 'event_card_navigation_id',
    pServiceCardExpanded: 'pService_card_expanded',
    prefLanguage: 'pref_lc',
    prefCountry: 'pref_cc',
    filterPreset: 'filterPreset',
    refreshToken: 'directus_refresh_token',
    accessToken: 'jwt_token',
    scrollPosition: 'scroll_position',
};

export const categoryIds: Record<TCategory, string> = {
    service: 'f57be8c4-eddf-4089-9b0e-542694109a6f',
    location: '9d095c14-c6af-47b4-85f9-ec510aefb3c2',
    event: '853a8162-ab77-4fff-bb3a-2e6e82bcb56b',
};

export const documentIds = {
    terms_of_use_sr: '3250f1b8-3244-4d84-81ef-218423b68515',
    terms_of_use_ru: '09afe67c-3ba2-40a7-9f28-f303d86bf012',
};

export const partnerServiceCategoryIds = {
    torgRs: '49dbab3f-6f69-4cf6-936b-ed9a2cc81728',
};

export const amplitudeEvents = {
    FILTER_SELECT_CLICK: 'Filter is applied',
    FILTER_REMOVE_CLICK: 'Filter is removed',
    EVENT_PROMOTED_OPEN: 'Event opened from promo carousel',
    EVENT_OPEN: 'Event opened',
    EVENT_CARD_YOUTUBE_LINK_CLICK: 'Youtube link is clicked',
    SEARCH_FORM_SUBMIT: 'Search form is submitted',
    RULER_CLICK: 'Ruler is clicked',
    SERVICE_CATEGORY_CLICK: 'Service category is clicked',
};

export const localeRegExp = {
    /** match[2] = language code, match[4] = country slug */
    exp: /^(\/([a-z]{2}))?(\/([a-z-]+))?([/?].*)?$/,
    country: (countrySlug: string) => `$1/${countrySlug}$5`,
    language: (languageCode: string) => `/${languageCode}$3$5`,
};

export const queryKeys = {
    filterPreset: 'preset',
};

export const dates = {
    today: dayjs().utc(),
    format: 'YYYY-MM-DD HH:mm:ss',
};
